import { render } from "./Wrapper.vue?vue&type=template&id=c29cb1f4"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=c29cb1f4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__